import { render, staticRenderFns } from "./tabbar2.vue?vue&type=template&id=de08d898&scoped=true"
import script from "./tabbar2.vue?vue&type=script&lang=js"
export * from "./tabbar2.vue?vue&type=script&lang=js"
import style0 from "./tabbar2.vue?vue&type=style&index=0&id=de08d898&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de08d898",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de08d898')) {
      api.createRecord('de08d898', component.options)
    } else {
      api.reload('de08d898', component.options)
    }
    module.hot.accept("./tabbar2.vue?vue&type=template&id=de08d898&scoped=true", function () {
      api.rerender('de08d898', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tabbar2.vue"
export default component.exports